import React, { useState, useEffect } from 'react';
import Preloader from './components/Preloader';
import ParticlesComponent from './components/ParticlesComponent';
import TopInfoBar from './components/TopInfoBar';
import HomePage from './components/HomePage';
import RobotResultsPage from './components/RobotResultsPage';
import SessionResultsPage from './components/SessionResultsPage';
import TryRobotPage from './components/TryRobotPage';
// حقن استيراد نقطة السيطرة الجديدة
import BookSessionPage from './components/BookSessionPage'; 
import Nav from './components/Nav';

declare global {
  interface Window {
    particlesJS: any;
    Swiper: any;
  }
}

// تحديث نوع Page ليشمل نقطة الوصول الجديدة
type Page = 'home' | 'robot-results' | 'session-results' | 'book-session' | 'try-robot';

export default function App() {
  const [loading, setLoading] = useState(true);
  // تأكد من تعريف setActivePage كدالة تحديث حالة React
  const [activePage, setActivePage] = useState<Page>('home');
  const [year, setYear] = useState<number>(new Date().getFullYear());
  const [showSubscribeDialog, setShowSubscribeDialog] = useState(false);
  const [showCongratsDialog, setShowCongratsDialog] = useState(false);

  // شاشة التحميل
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  // تحديث السنة تلقائياً
  useEffect(() => {
    const interval = setInterval(() => {
      setYear(new Date().getFullYear());
    }, 3600000);
    return () => clearInterval(interval);
  }, []);

  // نافذة الاشتراك
  useEffect(() => {
    const isSubscribed = localStorage.getItem('subscribedToChannel');
    if (!isSubscribed) {
      const timer = setTimeout(() => {
        setShowSubscribeDialog(true);
      }, 3500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleSubscribe = () => {
    window.open("https://www.youtube.com/@alpashmo7asb", "_blank");
    localStorage.setItem('subscribedToChannel', 'true');
    setShowSubscribeDialog(false);
    setTimeout(() => setShowCongratsDialog(true), 500);
  };

  if (loading) return <Preloader />;

  return (
    <>
      {/* تأثير الجزيئات الخلفي */}
      <ParticlesComponent />

      {/* شريط المعلومات العلوي */}
      <TopInfoBar />

      {/* المحتوى الرئيسي */}
      <main className="relative z-10 max-w-[1100px] mx-auto px-5 pt-9 pb-[120px]">
        {/* اللوجو */}
        <div className="logo w-[120px] h-[120px] md:w-[160px] md:h-[160px] mx-auto my-5 rounded-full flex items-center justify-center bg-[radial-gradient(#22ff9b22,transparent_55%)] shadow-[0_0_18px_#22ff9b22] transition-all duration-700 hover:scale-105">
          <img
            src="logo.png"
            alt="AL PASHMO7ASB Logo"
            className="w-[70%] drop-shadow-[0_0_12px_#22ff9b] animate-pulse"
          />
        </div>

        {/* العنوان الرئيسي */}
        <h1
          className="glitch text-[#22ff9b] text-[34px] md:text-[46px] font-black text-center mt-2"
          data-text="AL PASHMO7ASB"
        >
          AL PASHMO7ASB
        </h1>

        {/* التنقل بين الصفحات */}
        {/* تم تمرير دالة setActivePage بشكل لا لبس فيه */}
        <Nav activePage={activePage} setActivePage={setActivePage} />

        {/* محتوى الصفحة */}
        <div className="mt-8 transition-all duration-700">
          {activePage === 'home' && <HomePage />}
          {activePage === 'robot-results' && <RobotResultsPage />}
          {activePage === 'session-results' && <SessionResultsPage />}
          {/* منطق عرض نقطة السيطرة الجديدة */}
          {activePage === 'book-session' && <BookSessionPage />} 
          {activePage === 'try-robot' && <TryRobotPage />}
        </div>
      </main>

      {/* أيقونة يوتيوب */}
      <div className="fixed z-[10005] bottom-20 left-5 w-[50px] h-[50px] flex items-center justify-center rounded-full bg-[rgba(255,0,0,0.08)] border border-[rgba(255,0,0,0.2)] hover:bg-[rgba(255,0,0,0.15)] transition-all duration-500 backdrop-blur-md shadow-lg">
        <a
          href="https://www.youtube.com/@alpashmo7asb"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Visit YouTube Channel"
          className="flex items-center justify-center w-full h-full"
        >
          <i className="bx bxl-youtube text-[#ff4b4b] text-[26px] drop-shadow-[0_0_10px_#ff0000]"></i>
        </a>
      </div>

      {/* زر التلغرام */}
      <div className="fixed z-[10005] bottom-5 left-5 w-[50px] h-[50px] flex items-center justify-center rounded-full bg-[rgba(34,255,155,0.08)] border border-[rgba(34,255,155,0.2)] hover:bg-[rgba(34,255,155,0.15)] transition-all duration-500 backdrop-blur-md shadow-lg">
        <a
          href="https://t.me/m/FIrEmovvOTU0"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Join Telegram Channel"
          className="flex items-center justify-center w-full h-full"
        >
          <i className="bx bxl-telegram text-[#22ff9b] text-[24px]"></i>
        </a>
      </div>

      {/* نافذة الاشتراك */}
      {showSubscribeDialog && (
        <div className="fixed inset-0 z-[99999] bg-black/70 flex items-center justify-center backdrop-blur-sm animate-[fadeIn_0.5s_ease]">
          <div className="bg-[#0a1a13] border border-[#22ff9b44] rounded-2xl p-6 text-center shadow-[0_0_20px_#22ff9b33] w-[90%] md:w-[500px] scale-100 animate-[popIn_0.4s_ease]">
            <h2 className="text-[#22ff9b] text-2xl font-bold mb-3">اشترك الآن 📢</h2>
            <p className="text-[#cceee0] text-[17px] leading-relaxed">
              يجب الاشتراك في قناة <span className="text-[#22ff9b] font-semibold">البشمحاسب</span> على اليوتيوب للمتابعة.
            </p>
            <button
              onClick={handleSubscribe}
              className="mt-5 bg-[#22ff9b22] hover:bg-[#22ff9b33] border border-[#22ff9b66] text-[#22ff9b] font-bold py-2 px-6 rounded-full transition-all duration-300 hover:scale-105"
            >
              اشترك الآن
            </button>
          </div>
        </div>
      )}

      {/* نافذة التهنئة بعد الاشتراك */}
      {showCongratsDialog && (
        <div className="fixed inset-0 z-[99999] bg-black/70 flex items-center justify-center backdrop-blur-sm animate-[fadeIn_0.5s_ease]">
          <div className="bg-[#0a1a13] border border-[#22ff9b44] rounded-2xl p-6 text-center shadow-[0_0_20px_#22ff9b33] w-[90%] md:w-[480px] animate-[popIn_0.4s_ease]">
            <h2 className="text-[#22ff9b] text-2xl font-bold mb-3">🎉 مبروك!</h2>
            <p className="text-[#cceee0] text-[17px] leading-relaxed">
              أصبحت الآن من النخبة والفئة القليلة التي تعرف أسرار التداول 💹  
              استعد لاكتشاف الفرص الحقيقية وتحقيق أرباح غير متوقعة 🚀
            </p>
            <button
              onClick={() => setShowCongratsDialog(false)}
              className="mt-5 bg-[#22ff9b22] hover:bg-[#22ff9b33] border border-[#22ff9b66] text-[#22ff9b] font-bold py-2 px-6 rounded-full transition-all duration-300 hover:scale-105"
            >
              متابعة
            </button>
          </div>
        </div>
      )}

      {/* الفوتر */}
      <footer className="relative z-10 max-w-[1100px] mx-auto px-5 mt-8 mb-4">
        <div className="py-6 text-center text-[#9dbfb2] bg-[#071026]/80 border-t border-white/10 rounded-xl backdrop-blur-md shadow-inner">
          <p className="text-[#a3f9d4]">
            Built with 💚 by{' '}
            <strong className="text-[#22ff9b]">AL PASHMO7ASB</strong> — Empowering future traders.
          </p>
          <p className="text-[#bbb] mt-1">
            <i className="bx bx-copyright"></i> {year} AL PASHMO7ASB. All rights reserved.
          </p>
          <p className="text-[#ccc] mt-1">
            Contact:{' '}
            <a href="mailto:alpashmo7asb@gmail.com" className="text-[#22ff9b] hover:underline">
              alpashmo7asb@gmail.com
            </a>{' '}
            |{' '}
            <a href="https://t.me/m/FIrEmovvOTU0" className="text-[#22ff9b] hover:underline">
              @ALPASHMO7ASB
            </a>
          </p>
        </div>
      </footer>
    </>
  );
}